class BaoGifting {
  static PROPERTY_KEYS = Object.freeze({
    ID: '_gifting_id',
    CORE_PRODUCT: '_gifting_core_product',
    PACKAGING_PRODUCT: '_gifting_packaging_product',
    EXTRA_PRODUCT: '_gifting_extra_product',
    HIDE_FROM_CART: '_hide_from_cart',
    FREE_AFTER_1: '_free_after_1',
    GIFTING_MESSAGE: '_gifting_message',
    GIFT_MESSAGE: 'Gift Message',
  })

  /**
   * @param {string} uuid
   * @param {PotentialCartItem[]} currentItems
   * @param {GiftBar} giftingBar
   *
   * @return PotentialCartItem[]
   */
  static generateGiftingItems (uuid, currentItems, giftingBar) {
    const items = [...currentItems]

    /**
     * @param {PotentialCartItem[]} items
     *
     * @returns {PotentialCartItem[]}
     */
    function patchCoreItem (items) {
      items[0].properties = {
        ...items[0].properties,
        [BaoGifting.PROPERTY_KEYS.ID]: uuid,
        [BaoGifting.PROPERTY_KEYS.CORE_PRODUCT]: 'true',
        [BaoGifting.PROPERTY_KEYS.GIFTING_MESSAGE]: giftingBar.giftingMessage,
        [BaoGifting.PROPERTY_KEYS.GIFT_MESSAGE]: giftingBar.giftMessage,
      }

      return items
    }

    /**
     * @param {PotentialCartItem[]} items
     *
     * @returns {PotentialCartItem[]}
     */
    function appendGiftingItems (items) {
      const packagingId = giftingBar.packagingId

      if (packagingId) {
        items.push({
          id: packagingId.toString(),
          quantity: 1,
          properties: {
            [BaoGifting.PROPERTY_KEYS.ID]: uuid,
            [BaoGifting.PROPERTY_KEYS.PACKAGING_PRODUCT]: 'true',
            [BaoGifting.PROPERTY_KEYS.HIDE_FROM_CART]: 'true',
          },
        })
      }

      const extrasIds = giftingBar.extrasIds

      if (extrasIds.length > 0) {
        extrasIds.forEach((id, i) => {
          const freeItem = giftingBar.extrasIdsFree[i]

          items.push({
            id: id.toString(),
            quantity: 1,
            properties: {
              [BaoGifting.PROPERTY_KEYS.ID]: uuid,
              [BaoGifting.PROPERTY_KEYS.EXTRA_PRODUCT]: 'true',
              [BaoGifting.PROPERTY_KEYS.HIDE_FROM_CART]: 'true',
              [BaoGifting.PROPERTY_KEYS.FREE_AFTER_1]: freeItem,
            },
          })
        })
      }

      return items
    }

    return patchCoreItem(appendGiftingItems(items))
  }

  /**
   * @param {FormData} formData
   * @param {GiftBar} giftingBar
   *
   * @return FormData
   */
  static addGiftingItemsToFormData (formData, giftingBar) {
    const uuid = BaoGifting.getUniqueId()

    const [nextIndexKey] = [...formData.entries()]
      .reverse()
      .find(([key]) => key.startsWith('items['))
    const index = Number(nextIndexKey.split('][')[0].replace('items[', '')) + 1
    const initialIndex = index - 1

    formData.set(
      `items[${initialIndex}][properties][${BaoGifting.PROPERTY_KEYS.ID}]`,
      uuid,
    )
    formData.set(
      `items[${initialIndex}][properties][${BaoGifting.PROPERTY_KEYS.CORE_PRODUCT}]`,
      'true',
    )
    formData.set(
      `items[${initialIndex}][properties][${BaoGifting.PROPERTY_KEYS.GIFTING_MESSAGE}]`,
      giftingBar.giftingMessage,
    )
    formData.set(
      `items[${index - 1}][properties][${
        BaoGifting.PROPERTY_KEYS.GIFT_MESSAGE
      }]`,
      giftingBar.giftMessage,
    )

    const packagingId = giftingBar.packagingId

    if (packagingId) {
      formData.set(`items[${index}][id]`, packagingId.toString())
      formData.set(`items[${index}][quantity]`, '1')
      formData.set(
        `items[${index}][properties][${BaoGifting.PROPERTY_KEYS.ID}]`,
        uuid,
      )
      formData.set(
        `items[${index}][properties][${BaoGifting.PROPERTY_KEYS.PACKAGING_PRODUCT}]`,
        'true',
      )
      formData.set(
        `items[${index}][properties][${BaoGifting.PROPERTY_KEYS.HIDE_FROM_CART}]`,
        'true',
      )
    }

    let nextIndex = packagingId ? index : index - 1

    const extrasIds = giftingBar.extrasIds

    if (extrasIds.length > 0) {
      extrasIds.forEach((id, i) => {
        const freeItem = giftingBar.extrasIdsFree[i]

        nextIndex += 1

        formData.set(`items[${nextIndex}][id]`, id)
        formData.set(`items[${nextIndex}][quantity]`, '1')
        formData.set(
          `items[${nextIndex}][properties][${BaoGifting.PROPERTY_KEYS.ID}]`,
          uuid,
        )
        formData.set(
          `items[${nextIndex}][properties][${BaoGifting.PROPERTY_KEYS.EXTRA_PRODUCT}]`,
          'true',
        )
        formData.set(
          `items[${nextIndex}][properties][${BaoGifting.PROPERTY_KEYS.HIDE_FROM_CART}]`,
          'true',
        )
        formData.set(
          `items[${nextIndex}][properties][${BaoGifting.PROPERTY_KEYS.FREE_AFTER_1}]`,
          freeItem,
        )
      })
    }

    return formData
  }

  static getUniqueId () {
    return (Date.now() * Math.random()).toString()
  }
}

window.BAO.Gifting = BaoGifting
